export type StorageArea = "local" | "session";

const storageFor = (area: StorageArea): Storage => (area === "local" ? window.localStorage : window.sessionStorage);

export function readStored(area: StorageArea, key: string): string | null {
  try {
    return storageFor(area).getItem(key);
  } catch {
    return null;
  }
}

export function writeStored(area: StorageArea, key: string, value: string | null): void {
  try {
    if (value === null) {
      storageFor(area).removeItem(key);
    } else {
      storageFor(area).setItem(key, value);
    }
  } catch {
    // storage is a convenience; the app works without it
  }
}
